import { useState, type FormEvent } from "react";
import { LinkIcon, SparkleIcon } from "./Icons";

interface SetupScreenProps {
  mode: "bootstrap" | "missing-link";
  busy: boolean;
  error: string;
  onBootstrap: (names: string[]) => Promise<void>;
  onUseShareLink: (value: string) => void;
}

export function SetupScreen({ mode, busy, error, onBootstrap, onUseShareLink }: SetupScreenProps) {
  const [names, setNames] = useState(["", ""]);
  const [shareLink, setShareLink] = useState("");

  const submitBootstrap = (event: FormEvent) => {
    event.preventDefault();
    void onBootstrap(names);
  };

  const submitLink = (event: FormEvent) => {
    event.preventDefault();
    onUseShareLink(shareLink);
  };

  return (
    <main className="welcome-shell">
      <section className="welcome-card">
        <div className="brand-mark"><SparkleIcon /></div>
        <p className="eyebrow">OUR CLEAN HOME</p>
        <h1>おそうじ記録</h1>
        {mode === "bootstrap" ? (
          <>
            <p className="welcome-copy">ふたりの毎日を、気持ちよく。<br />まずは使う人の名前を教えてください。</p>
            <form className="setup-form" onSubmit={submitBootstrap}>
              {names.map((name, index) => (
                <label key={index}>
                  <span>{index + 1}人目</span>
                  <input
                    value={name}
                    maxLength={30}
                    placeholder={index === 0 ? "例：あおい" : "例：はる"}
                    autoComplete="off"
                    onChange={(event) => {
                      const next = [...names];
                      next[index] = event.target.value;
                      setNames(next);
                    }}
                  />
                </label>
              ))}
              {error && <p className="form-error" role="alert">{error}</p>}
              <button className="primary-button" disabled={busy || names.some((name) => !name.trim())}>
                {busy ? "準備しています…" : "はじめる"}
              </button>
            </form>
          </>
        ) : (
          <>
            <p className="welcome-copy">この端末には共有情報がありません。<br />もう一方の端末でコピーした共有URLを入力してください。</p>
            <form className="setup-form" onSubmit={submitLink}>
              <label>
                <span>共有URL</span>
                <div className="input-with-icon">
                  <LinkIcon />
                  <input
                    value={shareLink}
                    placeholder="https://…#key=…"
                    autoCapitalize="none"
                    autoCorrect="off"
                    onChange={(event) => setShareLink(event.target.value)}
                  />
                </div>
              </label>
              {error && <p className="form-error" role="alert">{error}</p>}
              <button className="primary-button" disabled={!shareLink.trim()}>共有データを開く</button>
            </form>
          </>
        )}
      </section>
    </main>
  );
}
